/**
 * An e-mail that was written but has not reached the server yet, kept for the life of this tab.
 *
 * TWO MOMENTS NEED THIS, AND BOTH USED TO LOSE WORK
 * -------------------------------------------------
 *  1. The preparation wizard creates the certificate and then saves the e-mail against it. Those
 *     are two requests, and when the second one failed the wizard reset itself anyway: the
 *     certificate existed, the message the author had written did not, and there was nothing left
 *     to retry from. It is remembered here instead, and the editor picks it up under the id the
 *     server gave — the same certificate, not a second one.
 *  2. Closing the e-mail dialog with unsaved changes dropped them without asking. They are kept
 *     here too, so reopening the dialog continues where the author left off.
 *
 * Held in memory, like the share text beside it: nothing is written to browser storage, and the
 * copy disappears with the tab rather than following somebody onto a shared machine.
 */
import type { CertificateEmailDraft } from '../data/template-email';

const drafts = new Map<string, CertificateEmailDraft>();

export function rememberPendingEmail(templateId: string, draft: CertificateEmailDraft): void {
  drafts.set(templateId, draft);
}

export function pendingEmail(templateId: string): CertificateEmailDraft | undefined {
  return drafts.get(templateId);
}

/** Called once the server has it: what is saved is no longer pending. */
export function forgetPendingEmail(templateId: string): void {
  drafts.delete(templateId);
}

/** Test isolation. Signing out or moving to another certificate never clears another's draft. */
export function forgetAllPendingEmails(): void {
  drafts.clear();
}
